define("shared/modifiers/tipalti-iframe-auto-height", ["exports", "@ember/debug", "ember-modifier"], function (_exports, _debug, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"ember-modifier"eaimeta@70e063a35619d71f
  /**
   *
   * TipaltiIframeAutoHeight sizes a Tipalti iFrame to its own content height, which the frame posts
   * as `{ TipaltiIframeInfo: { height } }` on load and on every step change. Only `height` is used —
   * the reported `width` fluctuates as Tipalti accounts for its own scrollbar.
   *
   * Usage:
   * <iframe src={{this.iframeUrl}} {{tipalti-iframe-auto-height}}></iframe>
   *
   */
  const tipaltiIframeAutoHeightModifier = (0, _emberModifier.modifier)(element => {
    (false && !(element instanceof HTMLIFrameElement) && (0, _debug.assert)('tipalti-iframe-auto-height expects an iframe', element instanceof HTMLIFrameElement));
    const onMessage = event => {
      if (event.source !== element.contentWindow) {
        return;
      }
      const height = event.data?.TipaltiIframeInfo?.height;
      if (typeof height === 'number' && height > 0) {
        element.style.height = `${height}px`;
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, {
    eager: false
  });
  var _default = _exports.default = tipaltiIframeAutoHeightModifier;
});